import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import PageBanner from "@/components/feature/PageBanner";
import ContactForm from "./components/ContactForm";
import { testimonials } from "@/mocks/topics";

const origin = typeof window !== "undefined" ? window.location.origin : "";
const prefix = (__BASE_PATH__ || "/").replace(/\/$/, "");
const siteUrl = `${origin}${prefix}`;

const positioning = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    text: "不是爆料号，也不是评论区。我们把公开信息整理成可读的文字档案，服务愿意花时间核对事实的读者。",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "发展理念",
    text: "慢一点，但准一点。与其抢第一时间，不如在一件事沉淀之后，交出一份经得起回看的整理。",
  },
  {
    icon: "ri-scales-3-line",
    title: "内容原则",
    text: "不编造、不夸大、不针对个人。凡有分歧的节点如实标注，凡未证实的说法不写成结论。",
  },
];

const principles = [
  {
    title: "只整理公开信息",
    text: "我们只使用公开发布的公告、说明与可核对的记录，不采用无法验证的私密材料，也不替来源不明的说法背书。",
  },
  {
    title: "分歧如实保留",
    text: "当同一节点存在多个版本时，我们会并列呈现并标注出处，而不是挑选更「好看」的那一个。",
  },
  {
    title: "不做道德审判",
    text: "观察笔记只讨论结构与节奏，例如回应速度、传播路径，不参与对个人品行的评判。",
  },
  {
    title: "错误及时修订",
    text: "如果整理出现偏差，我们会在文末标注修订记录并说明改动内容，而不是悄悄替换原文。",
  },
];

export default function About() {
  return (
    <SiteLayout>
      <PageMeta
        title="关于我们 · 黑料吃话的定位、理念与内容原则"
        description="黑料吃话是一个以文字实录为核心的内容平台。了解我们的网站定位、发展理念、内容原则与编辑流程，以及联系编辑部的方式与授权说明。"
        keywords="黑料吃话关于我们,黑料吃话内容原则,黑料吃话编辑部,联系我们"
        path="/about"
        type="website"
        breadcrumbs={[
          { name: "首页", path: "/" },
          { name: "关于我们", path: "/about" },
        ]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于黑料吃话",
            description: "黑料吃话的网站定位、发展理念与内容原则说明。",
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "黑料吃话",
            url: `${siteUrl}/`,
            email: "editor@heiliaochihua.cn",
            description: "专注于娱乐与网络热点文字整理的内容平台。",
          },
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "联系黑料吃话编辑部",
            description: "通过线索提交表单联系编辑部，可提交事件线索、内容纠错与授权申请。",
          },
        ]}
      />

      <PageBanner
        eyebrow="关于我们"
        title="黑料吃话：把热点整理成可回看的文字"
        description="我们相信，信息越多的时候，越需要有人把顺序理清楚。这里是我们做内容的方式、判断标准和联系渠道。"
        breadcrumbs={[{ name: "首页", path: "/" }, { name: "关于我们" }]}
      />

      <section className="bg-background-50 px-4 py-14 md:px-8 md:py-20">
        <div className="mx-auto w-full max-w-8xl">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-6">
              <div className="overflow-hidden rounded-lg border border-background-200 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20a%20warm%20cream%20research%20desk%20with%20an%20open%20laptop%20showing%20a%20timeline%20chart%2C%20pinned%20notes%20on%20a%20soft%20corkboard%20and%20a%20cup%20of%20coffee%2C%20natural%20window%20light%2C%20muted%20vermillion%20and%20amber%20accents%2C%20calm%20organized%20archival%20mood%2C%20clean%20minimal%20composition&width=1400&height=1000&seq=hc-about-02&orientation=landscape"
                  alt="黑料吃话 编辑部的资料核对流程"
                  title="黑料吃话 · 资料核对与整理流程"
                  className="h-64 w-full object-cover object-top md:h-[420px]"
                />
              </div>
            </div>
            <div className="lg:col-span-6">
              <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-400" />
                品牌介绍
              </div>
              <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                我们为什么做「文字版」
              </h2>
              <div className="mt-5 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                <p>
                  一场风波里，最容易被忽略的往往是顺序。谁先说的、什么时候回应的、公告改过几次——
                  这些细节决定了我们对一件事的理解，却常常散落在不同的截图与转发之间。
                </p>
                <p>
                  黑料吃话做的，就是把这些碎片重新排列。我们用时间线还原经过，用对话实录保留语气，
                  用观察笔记记录传播的节奏，让读者能在五分钟内建立完整的认知框架。
                </p>
                <p>
                  站内所有示例内容均为虚构或经过匿名化处理的行业观察样本，目的是演示整理方法，
                  而非对现实中任何具体个人作出指认。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
            {positioning.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-800">
                  <i className={item.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
        <div className="mx-auto w-full max-w-8xl">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-400" />
                内容原则
              </div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                四条不会妥协的编辑底线
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                这些原则写在这里，也写在每一份档案的制作流程里。如果你发现我们偏离了它们，欢迎直接指出。
              </p>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
              {principles.map((item, index) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="font-heading text-sm font-bold text-primary-500">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-14 border-t border-background-200 pt-12">
            <h3 className="font-heading text-lg font-semibold text-foreground-950">读者反馈</h3>
            <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
                >
                  <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                    {item.text}
                  </blockquote>
                  <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                      {item.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-sm font-medium text-foreground-900">
                        {item.name}
                      </span>
                      <span className="block text-xs text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="scroll-mt-24 bg-background-50 px-4 py-14 md:px-8 md:py-20">
        <div className="mx-auto w-full max-w-8xl">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-400" />
                联系方式
              </div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                有话想对我们说
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                无论是事件线索、内容纠错，还是引用与授权申请，都可以通过下面的表单或邮箱联系我们。
              </p>

              <div className="mt-7 space-y-4">
                <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-mail-line text-lg" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">编辑部邮箱</p>
                    <p className="mt-0.5 text-sm text-foreground-600">editor@heiliaochihua.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className="ri-time-line text-lg" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">处理时效</p>
                    <p className="mt-0.5 text-sm text-foreground-600">
                      工作日 10:00 - 19:00，1 至 2 个工作日内回复
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-shield-check-line text-lg" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">信息使用</p>
                    <p className="mt-0.5 text-sm text-foreground-600">
                      仅用于内容核实，不会公开你的个人联系方式
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}